<div class="standard-dialog dialog-refund-order-wrapper" *ngIf="loadedContent">
  <div class="dialog-header">
    <p class="title">Resumen devolución</p>
    <div class="subtitle-wrapper">
      <p class="subtitle">Pedido #{{orderInfo.id_invoicing}}</p>
      <p class="link-to-order" (click)="goToDetail()">Ir al pedido</p>
    </div>
  </div>
  <div class="dialog-content">
    <div class="order-section">
      <p class="title-order">Se devolverá lo siguiente:</p>
      <div class="scrolleable-content">
        <div class="event-wrapper" *ngFor="let line of bookingsOrder">
          <div class="event-header">
            <p class="title">{{line.event.title}}</p>
            <p class="info">{{line.session.start_date | date: 'dd MMM':'+0000'}} | {{line.session.start_date | date: 'HH:mm': '+0000'}}h
            </p>
            <p class="info" *ngIf="line?.event.space">{{line.event.space.name}} - {{line.event.space.address}}</p>
            <p class="info">{{line.event.company.name}}</p>
          </div>
          <div class="ticket-wrapper" *ngFor="let bookingTicket of line.bookings">
            <div class="ticket-title">
              <p>{{bookingTicket.ticket.name}}</p>
            </div>
            <div class="ticket-info">
              <div>
                <p *ngIf="bookingTicket?.booking.seat" class="seat">Zona:
                  {{bookingTicket.booking.seat.map_section?.name}}, Fila: {{bookingTicket.booking.seat.row}},
                  Asiento:
                  {{bookingTicket.booking.seat.seat}}</p>
              </div>
              <p class="price">{{+bookingTicket.price | number:'1.2-2'}}€</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button class="action-button secondary-button" (click)="closeDialog()">Volver atrás</button>
    <button class="action-button primary-button" (click)="refundOrder()">Devolver pedido</button>
  </div>
</div>